export default __webpack_public_path__ + "static/media/cut.1f517cbc.svg";